<template>
    <div>
        <el-dialog
            title="志愿者"
            class="dialog_container"
            :visible.sync="zhiyuanzheId.state"
            width="60%"
            :before-close="handleClose"
            append-to-body
        >
            <div class="zhiyuanzhe">
                <div
                    v-for="(item, index) in titleList"
                    :key="index"
                    class="title-list"
                    :class="{ change: tapIndex == item.id }"
                    @click="changeId(item.id)"
                >
                    {{ item.name }}
                </div>
            </div>

            <div v-show="tapIndex == 1">
                <div class="tap1">
                    <div class="tap1-left">
                        <div>用户姓名：</div>
                        <div>
                            <el-input
                                size="medium"
                                style="width: 300px"
                                disabled
                                v-model="formData.userName"
                            ></el-input>
                        </div>
                    </div>
                    <div class="tap1-right">
                        <div>电子邮箱：</div>
                        <div>
                            <el-input
                                size="medium"
                                style="width: 300px"
                                disabled
                                v-model="formData.email"
                            ></el-input>
                        </div>
                    </div>
                </div>
                <div class="tap1">
                    <div class="tap1-left">
                        <div>身份证号：</div>
                        <div>
                            <el-input
                                size="medium"
                                style="width: 300px"
                                disabled
                                v-model="formData.idCardNo"
                            ></el-input>
                        </div>
                    </div>
                    <div class="tap1-right">
                        <div>性别：</div>
                        <div>
                            <el-input
                                size="medium"
                                style="width: 300px"
                                disabled
                                v-model="formData.sex"
                            ></el-input>
                        </div>
                    </div>
                </div>
                <div class="tap1">
                    <div class="tap1-left">
                        <div>出生日期：</div>
                        <div>
                            <el-input
                                size="medium"
                                style="width: 300px"
                                disabled
                                v-model="formData.birthday"
                            ></el-input>
                        </div>
                    </div>
                    <div class="tap1-right">
                        <div>政治面貌：</div>
                        <div>
                            <el-select
                                v-model="formData.polity"
                                placeholder="请选择政治面貌"
                                style="width: 300px"
                                size="medium"
                                disabled
                            >
                                <el-option
                                    label="中国共产党党员"
                                    value="0"
                                ></el-option>
                                <el-option
                                    label="中国共产党预备党员"
                                    value="1"
                                ></el-option>
                                <el-option
                                    label="中国共产党党员(保留团籍)"
                                    value="2"
                                ></el-option>
                                <el-option
                                    label="中国共产主义青年团团员"
                                    value="3"
                                ></el-option>
                                <el-option
                                    label="中国国名党革命委员会会员"
                                    value="4"
                                ></el-option>
                                <el-option
                                    label="中国民主同盟盟员"
                                    value="5"
                                ></el-option>
                                <el-option
                                    label="中国民主建国会会员"
                                    value="6"
                                ></el-option>
                                <el-option
                                    label="中国民主促进会会员"
                                    value="7"
                                ></el-option>
                                <el-option
                                    label="中国农工民主党党员"
                                    value="8"
                                ></el-option>
                                <el-option
                                    label="中国致公党党员"
                                    value="9"
                                ></el-option>
                                <el-option
                                    label="九三学社社员"
                                    value="11"
                                ></el-option>
                                <el-option
                                    label="台湾民主自治同盟盟员"
                                    value="12"
                                ></el-option>
                                <el-option
                                    label="无党派民主人士"
                                    value="13"
                                ></el-option>
                                <el-option
                                    label="中国少年先锋队队员"
                                    value="14"
                                ></el-option>
                                <el-option label="群众" value="15"></el-option>
                            </el-select>
                        </div>
                    </div>
                </div>
                <div class="tap1">
                    <div class="tap1-left">
                        <div>民族：</div>
                        <div>
                            <el-select
                                disabled
                                v-model="formData.nation"
                                placeholder="请选择民族"
                                style="width: 300px"
                            >
                                <el-option
                                    :label="item"
                                    :value="index"
                                    v-for="(item, index) in nation"
                                    :key="index"
                                ></el-option>
                            </el-select>
                        </div>
                    </div>
                    <div class="tap1-right">
                        <div>籍贯：</div>
                        <div>
                            <el-input
                                size="medium"
                                style="width: 300px"
                                disabled
                                v-model="formData.nativePlace"
                            ></el-input>
                        </div>
                    </div>
                </div>
                <div class="tap1">
                    <div class="tap1-left">
                        <div>手机：</div>
                        <div>
                            <el-input
                                size="medium"
                                style="width: 300px"
                                disabled
                                v-model="formData.mobile"
                            ></el-input>
                        </div>
                    </div>
                    <div class="tap1-right">
                        <div>固定电话：</div>
                        <div>
                            <el-input
                                size="medium"
                                style="width: 300px"
                                disabled
                                v-model="formData.fixedTelephone"
                            ></el-input>
                        </div>
                    </div>
                </div>
                <div class="tap1">
                    <div class="tap1-left">
                        <div>QQ：</div>
                        <div>
                            <el-input
                                size="medium"
                                style="width: 300px"
                                disabled
                                v-model="formData.qqAccount"
                            ></el-input>
                        </div>
                    </div>
                    <div class="tap1-right">
                        <div>学历：</div>
                        <div>
                            <el-select
                                disabled
                                v-model="formData.education"
                                size="medium"
                                style="width: 300px"
                            >
                                <el-option label="小学" value="0"></el-option>
                                <el-option label="初中" value="1"></el-option>
                                <el-option label="高中" value="2"></el-option>
                                <el-option label="职校" value="3"></el-option>
                                <el-option label="专科" value="4"></el-option>
                                <el-option label="本科" value="5"></el-option>
                                <el-option label="硕士" value="6"></el-option>
                                <el-option label="博士" value="7"></el-option>
                                <el-option label="其他" value="8"></el-option>
                            </el-select>
                        </div>
                    </div>
                </div>

                <div class="addressFrom">
                <div class="addressTitle">居住地地址:</div>
                <div class="addressContent">
                    <div class="addressBox">
                        <div class="addressItem">
                            <el-select
                            disabled
                            v-model="formData.shengId"
                            placeholder="请选择省"
                            @change="handleProvince"
                            ref="selectShengChange"
                            >
                            <el-option
                                v-for="(item, index) in provinceList"
                                :key="index"
                                :label="item.name"
                                :value="item.adcode"
                            >
                            </el-option>
                            </el-select>
                    </div>
                    <div class="addressItem">
                            <el-select
                            disabled
                            v-model="formData.shiId"
                            placeholder="请选择市"
                            @change="handleCity"
                            ref="selectShiChange"
                            >
                            <el-option
                                v-for="(item, index) in cityList"
                                :key="index"
                                :label="item.name"
                                :value="item.adcode"
                            >
                            </el-option>
                            </el-select>
                    </div>
                    <div class="addressItem">
                            <el-select
                            v-model="formData.quId"
                            disabled
                            placeholder="请选择区"
                            @change="handleArea"
                            ref="selectQuChange"
                            >
                            <el-option
                                v-for="(item, index) in areaList"
                                :key="index"
                                :label="item.name"
                                :value="item.adcode"
                            >
                            </el-option>
                            </el-select>
                    </div>
                    <div class="addressItem">
                            <el-select
                            disabled
                            v-model="formData.jiedaoId"
                            placeholder="请选择街道"
                            @change="streetChange"
                            ref="selectJiedaoChange"
                            >
                            <el-option
                                v-for="(item, index) in streetList"
                                :key="index"
                                :label="item.name"
                                :value="item.adcode + index"
                            >
                            </el-option>
                            </el-select>
                    </div>
                    <div class="addressItem">
                            <el-select
                            disabled
                            v-model="formData.shequId"
                            placeholder="请选择社区"
                            ref="selectShequChange"
                            @change="handleCommunityChange"
                            >
                            <el-option
                                v-for="item in communityList"
                                :key="item.id"
                                :label="item.address"
                                :value="item.id"
                            >
                            </el-option>
                            </el-select>
                    </div>
                    </div>
                </div>
                </div>

                <div class="map_container1">
                    <div
                        id="container1"
                        style="width: 100%; height: 200px"
                        disabled
                    ></div>
                </div>
                <div class="tap1">
                    <div class="tap1-left">
                        <div>受邀参加项目：</div>
                        <div>
                            <el-radio-group v-model="formData.isJoin" disabled>
                                <el-radio label="0">是</el-radio>
                                <el-radio label="1">否</el-radio>
                            </el-radio-group>
                        </div>
                    </div>
                    <div class="tap1-right">
                        <div>特长：</div>
                        <div>
                            <el-select
                                disabled
                                v-model="formData.goodAt"
                                style="width: 300px"
                            >
                                <el-option label="书法" value="0"></el-option>
                                <el-option label="绘画" value="1"></el-option>
                                <el-option label="料理" value="2"></el-option>
                                <el-option label="羽毛球" value="3"></el-option>
                                <el-option label="乒乓球" value="4"></el-option>
                                <el-option label="其他" value="5"></el-option>
                            </el-select>
                        </div>
                    </div>
                </div>

                <div class="tap1">
                    <div class="tap1-unit">
                        <div>注册服务时长：</div>
                        <div>
                            <el-input
                                size="medium"
                                disabled
                                v-model="formData.serviceTime"
                            ></el-input>
                        </div>
                    </div>
                </div>
                <div class="tap1">
                    <div class="tap1-unit">
                        <div>图片：</div>
                        <div><img :src="formData.photo" alt="" /></div>
                    </div>
                </div>
            </div>

            <div v-show="tapIndex == 2">
                <div class="tap2">
                    <div class="tap2-left">服务时长：</div>
                    <div class="tap2-content">
                        <div>周一</div>
                        <div>
                            <el-checkbox
                                v-model="serverList[0].timeSlot0"
                                disabled
                                >上午</el-checkbox
                            >
                        </div>
                        <div>
                            <el-checkbox
                                v-model="serverList[1].timeSlot0"
                                disabled
                                >下午</el-checkbox
                            >
                        </div>
                    </div>
                    <div class="tap2-content">
                        <div>周二</div>
                        <div>
                            <el-checkbox
                                v-model="serverList[0].timeSlot1"
                                disabled
                                >上午</el-checkbox
                            >
                        </div>
                        <div>
                            <el-checkbox
                                v-model="serverList[1].timeSlot1"
                                disabled
                                >下午</el-checkbox
                            >
                        </div>
                    </div>
                    <div class="tap2-content">
                        <div>周三</div>
                        <div>
                            <el-checkbox
                                v-model="serverList[0].timeSlot2"
                                disabled
                                >上午</el-checkbox
                            >
                        </div>
                        <div>
                            <el-checkbox
                                v-model="serverList[1].timeSlot2"
                                disabled
                                >下午</el-checkbox
                            >
                        </div>
                    </div>
                    <div class="tap2-content">
                        <div>周四</div>
                        <div>
                            <el-checkbox
                                v-model="serverList[0].timeSlot3"
                                disabled
                                >上午</el-checkbox
                            >
                        </div>
                        <div>
                            <el-checkbox
                                v-model="serverList[1].timeSlot3"
                                disabled
                                >下午</el-checkbox
                            >
                        </div>
                    </div>
                    <div class="tap2-content">
                        <div>周五</div>
                        <div>
                            <el-checkbox
                                v-model="serverList[0].timeSlot4"
                                disabled
                                >上午</el-checkbox
                            >
                        </div>
                        <div>
                            <el-checkbox
                                v-model="serverList[1].timeSlot4"
                                disabled
                                >下午</el-checkbox
                            >
                        </div>
                    </div>
                    <div class="tap2-content">
                        <div>周六</div>
                        <div>
                            <el-checkbox
                                v-model="serverList[0].timeSlot5"
                                disabled
                                >上午</el-checkbox
                            >
                        </div>
                        <div>
                            <el-checkbox
                                v-model="serverList[1].timeSlot5"
                                disabled
                                >下午</el-checkbox
                            >
                        </div>
                    </div>
                    <div class="tap2-content">
                        <div>周日</div>
                        <div>
                            <el-checkbox
                                v-model="serverList[0].timeSlot6"
                                disabled
                                >上午</el-checkbox
                            >
                        </div>
                        <div>
                            <el-checkbox
                                v-model="serverList[1].timeSlot6"
                                disabled
                                >下午</el-checkbox
                            >
                        </div>
                    </div>
                </div>
                <div>
                    <div class="team2">
                        <div>服务类别：</div>
                        <div style="width: 80%; line-height: 30px">
                            <el-checkbox-group v-model="serverTypeList">
                                <el-checkbox label="0" disabled
                                    >赛会服务</el-checkbox
                                >
                                <el-checkbox label="1" disabled
                                    >应急救援</el-checkbox
                                >
                                <el-checkbox label="2" disabled
                                    >城市运行</el-checkbox
                                >
                                <el-checkbox label="3" disabled
                                    >文化教育</el-checkbox
                                >
                                <el-checkbox label="4" disabled
                                    >关爱教育</el-checkbox
                                >
                                <el-checkbox label="5" disabled
                                    >社区服务</el-checkbox
                                >
                                <el-checkbox label="6" disabled
                                    >医疗卫生</el-checkbox
                                >
                                <el-checkbox label="7" disabled
                                    >其他</el-checkbox
                                >
                            </el-checkbox-group>
                        </div>
                    </div>
                </div>
            </div>

            <div v-show="tapIndex == 3">
                <div class="tap3">
                    <el-table
                        :data="teamList"
                        tooltip-effect="dark"
                        style="width: 100%"
                        :header-cell-style="{
                            background: '#e6e6e6',
                            color: '#000',
                        }"
                        border
                    >
                        <el-table-column
                            type="index"
                            width="50"
                            prop="id"
                            label="序号"
                            align="center"
                        ></el-table-column>
                        <el-table-column
                            prop="name"
                            label="团队名称"
                            width="180"
                            align="center"
                            :show-overflow-tooltip="true"
                        ></el-table-column>

                        <el-table-column
                            prop="formalMembers"
                            label="团队人数"
                            width="120"
                            align="center"
                            :show-overflow-tooltip="true"
                        ></el-table-column>
                        <el-table-column
                            prop="contacts"
                            label="联系人"
                            align="center"
                            width="120"
                            :show-overflow-tooltip="true"
                        ></el-table-column>

                        <el-table-column
                            prop="phone"
                            width="120"
                            label="联系方式"
                            align="center"
                            :show-overflow-tooltip="true"
                        ></el-table-column>
                        <el-table-column
                            prop="address"
                            label="团队地址"
                            align="center"
                            :show-overflow-tooltip="true"
                        ></el-table-column>
                    </el-table>

                    <div class="pagination_container">
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :page-sizes="[10, 20, 40, 100]"
                            :page-size="query.pageSize"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="tempTotal"
                        >
                        </el-pagination>
                    </div>
                </div>
            </div>

            <div v-show="tapIndex == 4">
                <div class="tap4">
                    <div>技能特长：</div>
                    <el-input
                        disabled
                        type="textarea"
                        v-model="formData.otherGoodAt"
                        :rows="6"
                        class="tap4-text"
                    ></el-input>
                </div>
                <div class="tap4">
                    <div>综合评价：</div>
                    <el-input
                        disabled
                        type="textarea"
                        v-model="formData.comprehensiveEvaluate"
                        :rows="6"
                        class="tap4-text"
                    ></el-input>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import request from "@/utils/request.js"
export default {
  props: ["zhiyuanzheId"],
  data() {
    return {
      query: {
        pageNo: 1,
        pageSize: 10,
      },
      normalInfo: {},
      provinceList: [], //省列表
      cityList: [], //市列表
      areaList: [], //区列表
      streetList: [], //街道列表
      communityList: [], //社区列表
      city: "",
      district: "",
      province: "",
      nation: [
        //民族
        "汉族",
        "蒙古族",
        "回族",
        "藏族",
        "维吾尔族",
        "苗族",
        "彝族",
        "壮族",
        "布依族",
        "朝鲜族",
        "满族",
        "侗族",
        "瑶族",
        "白族",
        "土家族",
        "哈尼族",
        "哈萨克族",
        "傣族",
        "黎族",
        "傈僳族",
        "佤族",
        "畲族",
        "高山族",
        "拉祜族",
        "水族",
        "东乡族",
        "纳西族",
        "景颇族",
        "柯尔克孜族",
        "土族",
        "达斡尔族",
        "仫佬族",
        "羌族",
        "布朗族",
        "撒拉族",
        "毛南族",
        "仡佬族",
        "锡伯族",
        "阿昌族",
        "普米族",
        "塔吉克族",
        "怒族",
        "乌孜别克族",
        "俄罗斯族",
        "鄂温克族",
        "德昂族",
        "保安族",
        "裕固族",
        "京族",
        "塔塔尔族",
        "独龙族",
        "鄂伦春族",
        "赫哲族",
        "门巴族",
        "珞巴族",
        "基诺族",
        "其他",
        "外籍血统中国籍人士",
      ],
      myMap: null,
      isMap: true,
      list: [],
      marker: [],
      teamList: [],
      tempTotal: 0,
      serverTypeList: [],
      serverList: [
        {
          timeSlot0: false,
          timeSlot1: false,
          timeSlot2: false,
          timeSlot3: false,
          timeSlot4: false,
          timeSlot5: false,
          timeSlot6: false,
        },
        {
          timeSlot0: false,
          timeSlot1: false,
          timeSlot2: false,
          timeSlot3: false,
          timeSlot4: false,
          timeSlot5: false,
          timeSlot6: false,
        },
      ],
      formData: {},
      map: null,
      tapIndex: "1",
      dialogVisible: false,
      titleList: [
        {
          id: "1",
          name: "个人基本信息",
        },
        {
          id: "2",
          name: "服务意愿",
        },
        {
          id: "3",
          name: "所属团队",
        },
        {
          id: "4",
          name: "其他信息",
        },
      ],
      signUpTableData: [
        {
          name: "a啊",
        },
        {
          name: "a啊",
        },
        {
          name: "a啊",
        },
      ],
    }
  },
  async mounted() {
    this.getData()
    await this.$nextTick(function () {
      setTimeout(() => {
        this.loadMap()
      }, 30)
    })
  },
  created() {},
  methods: {
    getData() {
      this.getProvince()
      this.changeFirst()
      request({
        url: "/sqyl/admin/volunteerArchive/info/get",
        method: "POST",
        data: {
          id: this.zhiyuanzheId.id,
        },
      }).then(async (res) => {
        if (res.code == 200) {
          this.formData = res.content
          if (res.content.gender == "1") {
            this.formData.sex = "男"
          } else {
            this.formData.sex = "女"
          }
          this.formData.nation = res.content.nativePlace
          const content = res.content
          if (content.shengId) {
              content.shengId = String(content.shengId)
            }
            if (content.shiId) {
              content.shiId = String(content.shiId)
            }
            if (content.quId) {
              content.quId = String(content.quId)
            }
            if (content.jiedaoId) {
              content.jiedaoId = String(content.jiedaoId)
            }
            if (content.shequId) {
              content.shequId = Number(content.shequId)
            }
             if (!this.formData.shengId) return
            let city = await this.getDistrict(this.formData.shengId)
            this.cityList = city.districtList
            if (!this.formData.shiId) return
            let area = await this.getDistrict(this.formData.shiId)
            this.areaList = area.districtList
            if (!this.formData.quId) return
            let street = await this.getDistrict(this.formData.quId)
            this.streetList = street.districtList
            if (!this.formData.jiedaoId) return
            let communityList = await this.getCommityList(
              this.formData.jiedaoId
            )
            this.communityList = communityList
            this.formData.shequId = Number(this.formData.shequId)
            setTimeout(async () => {
              await this.$nextTick(() => {
                this.loadMap("container1")
                this.potintMap()
              })
            }, 30)
          // this.teamList = res.content.crList.filter(
          //     (item) => item && item.approvalStatus == 1
          // )
          // this.tempTotal = this.teamList.length
          // this.formData = res.content
          // this.serverList = JSON.parse(res.content.serviceTimeSlot)

          // if (res.content.serviceType) {
          //     this.serverTypeList = res.content.serviceType.split(",")
          // }

          // this.$nextTick(function () {
          //     setTimeout(() => {
          //         this.joinAddress(this.formData.address)
          //     }, 30)
          // })
          
        } else if (res.code == "10004") {
          this.$message.error(res.message)
          this.$router.push("/login")
        }
      })
    },
    handleClose() {
      this.$emit("setShow")
      this.dialogVisible = false
    },
    changeId(id) {
      this.tapIndex = id
    },
    loadMap() {
      //地图加载
      return new Promise((resolve, reject) => {
        this.map = new AMap.Map("container1", {
          resizeEnable: true,

          zoom: 8,
        })
        resolve()
      })
    },
    //获取省级
    async getProvince() {
      this.provinceLis = []
      this.cityList = []
      this.areaList = []
      this.streetList = []
      let province = await this.getDistrict()
      this.provinceList = province.districtList
    },
    //  省级地址选择发生改变
    async handleProvince(val) {
      this.cityList = []
      this.areaList = []
      this.streetList = []
      this.communityList = []
      this.formData.shiId = ""
      this.formData.quId = ""
      this.formData.jiedaoId = ""
      this.formData.shequId = ""
      this.formData.detailAddress = ""
      let city = await this.getDistrict(val)
      this.cityList = city.districtList
      this.joinAddress()
    },
    //市级地址发生改变
    async handleCity(val) {
      this.areaList = []
      this.streetList = []
      this.communityList = []
      this.formData.quId = ""
      this.formData.jiedaoId = ""
      this.formData.shequId = ""
      this.formData.detailAddress = ""
      let area = await this.getDistrict(val)
      this.areaList = area.districtList
      this.joinAddress()
    },
    //县区级地址发生改变
    async handleArea(val) {
      this.streetList = []
      this.communityList = []
      this.formData.jiedaoId = ""
      this.formData.shequId = ""
      this.formData.detailAddress = ""
      // val = val.replace(/.$/, "");
      let street = await this.getDistrict(val)
      this.streetList = street.districtList
      this.joinAddress()
    },
    // 打点
    potintMap() {
      var map = new AMap.Map("container1", {
        resizeEnable: true,
        zoom: 8,
        // zooms: [3, 20],
        expandZoomRange: true,
        center: [
          Number(this.formData.longitude),
          Number(this.formData.latitude),
        ],
      })
      var marker = new AMap.Marker({
        position: [
          Number(this.formData.longitude),
          Number(this.formData.latitude),
        ],
        map: map,
      })
      map.setFitView(marker)
    },
    //街道地址发生变化
    async streetChange(val) {
      let communityList = await this.getCommityList(val)
      console.log(communityList, "社区列表")
      this.communityList = communityList
      this.joinAddress()
    },
    handleCommunityChange(val) {
      this.$nextTick(() => {
        this.$forceUpdate()
        this.joinAddress()
      })
    },
    handleSizeChange(val) {
      this.query.pageSize = val
    },
    handleCurrentChange(val) {
      this.query.pageNo = val
    },
    joinAddress(address = "") {
      let self = this
      self.$nextTick(() => {
        let geocoder = new AMap.Geocoder({
          city: "",
        })
        self.marker = new AMap.Marker()
        geocoder.getLocation(
          self.formData.detailAddress,
          function (status, result) {
            if (status === "complete" && result.geocodes.length) {
              self.province = result.geocodes[0].addressComponent.province
              self.city = result.geocodes[0].addressComponent.city
              self.district = result.geocodes[0].addressComponent.district
              let lnglat = result.geocodes[0].location
              self.formData.longitude = lnglat.lng
              self.formData.latitude = lnglat.lat
              self.marker.setPosition(lnglat)
              self.map.add(self.marker)
              self.map.setFitView(self.marker)
            } else {
              log.error("根据地址查询位置失败")
            }
          }
        )
      })
    },
    async changeFirst() {
      if (this.normalInfo.provinceId == 0) {
        this.normalInfo.provinceId = ""
      } else {
        this.normalInfo.provinceId = String(this.normalInfo.provinceId)
        let cityList = await this.getDistricts(this.normalInfo.provinceId)
        this.cityList = cityList.districtList
      }
      if (this.normalInfo.cityId) {
        this.normalInfo.cityId = String(this.normalInfo.cityId)
        let areaList = await this.getDistricts(this.normalInfo.cityId)
        this.areaList = areaList.districtList
      } else {
        this.normalInfo.cityId = ""
      }

      if (this.normalInfo.areaId) {
        this.normalInfo.areaId = String(this.normalInfo.areaId)
        let streetList = await this.getDistricts(this.normalInfo.areaId)
        this.streetList = streetList.districtList
      } else {
        this.normalInfo.areaId = ""
      }
      if (this.normalInfo.streetId) {
        this.normalInfo.streetId = String(this.normalInfo.streetId)
        let communityList = await this.getCommityList(this.normalInfo.streetId)
        this.communityList = communityList
      } else {
        this.normalInfo.streetId = ""
      }
      if (this.normalInfo.orgLevel == 1 || this.normalInfo.orgLevel == 0) {
        this.provinceList.forEach((item) => {
          if (item.adcode == this.normalInfo.provinceId) {
            this.formData.latitude = item.center.lat
            this.formData.longitude = item.center.lng
          }
        })
      } else if (this.normalInfo.orgLevel == 2) {
        this.cityList.forEach((item) => {
          if (item.adcode == this.normalInfo.cityId) {
            this.formData.latitude = item.center.lat
            this.formData.longitude = item.center.lng
          }
        })
      } else if (this.normalInfo.orgLevel == 3) {
        this.areaList.forEach((item) => {
          if (item.adcode == this.normalInfo.areaId) {
            this.formData.latitude = item.center.lat
            this.formData.longitude = item.center.lng
          }
        })
      } else if (
        this.normalInfo.orgLevel == 4 ||
        this.normalInfo.orgLevel == 5
      ) {
        this.streetList.forEach((item, index) => {
          if (item.adcode + index == this.normalInfo.streetId) {
            this.formData.latitude = item.center.lat
            this.formData.longitude = item.center.lng
          }
        })
      }

      if (this.normalInfo.communityId) {
        this.normalInfo.communityId = Number(this.normalInfo.communityId)
      } else {
        this.normalInfo.communityId = ""
      }

      this.formData.shengId = this.normalInfo.provinceId
      this.formData.shiId = this.normalInfo.cityId
      this.formData.quId = this.normalInfo.areaId
      this.formData.jiedaoId = this.normalInfo.streetId
      this.formData.shequId = this.normalInfo.communityId
      setTimeout(async () => {
        await this.$nextTick(() => {
          this.loadMap("container1")
          this.potintMap()
        })
      }, 30)
      this.$forceUpdate()
    },
    //获取地址
    getDistricts(name = "中国", params = null) {
      let self = this
      return new Promise((resolve, reject) => {
        var opts = {
          subdistrict: 1, //返回下一级行政区
          extensions: "all",
          showbiz: false, //最后一级返回街道信息
        }
        let district = new AMap.DistrictSearch(opts)
        let geocoder = new AMap.Geocoder({
          city: "", //城市设为北京，默认：“全国”
          radius: 1000, //范围，默认：500
        })
        try {
          self.myMap.remove(self.marker)
        } catch (err) {}

        self.marker = new AMap.Marker()
        district.search(name, (status, result) => {
          if (status == "complete") {
            resolve(result.districtList[0])
            if (this.isMap) {
              this.isMap = false
              return
            }
            let bounds = result.districtList[0].boundaries
            self.polygon = null
          }
        })
      }).catch((err) => {})
    },
    //获取地址
    getDistrict(name = "中国", params = null) {
      let self = this
      return new Promise((resolve, reject) => {
        var opts = {
          subdistrict: 1, //返回下一级行政区
          extensions: "all",
          showbiz: false, //最后一级返回街道信息
        }
        let district = new AMap.DistrictSearch(opts)
        let geocoder = new AMap.Geocoder({
          city: "", //城市设为北京，默认：“全国”
          radius: 1000, //范围，默认：500
        })
        try {
          const MarkerList = self.myMap
            .getAllOverlays()
            .filter((item) => item.CLASS_NAME === "AMap.Marker")
          self.myMap.remove(MarkerList)
          self.myMap.remove(self.marker)
        } catch (err) {}
        self.marker = new AMap.Marker()
        district.search(name, (status, result) => {
          if (status == "complete") {
            resolve(result.districtList[0])
            if (this.isMap) {
              this.isMap = false
              return
            }
            let bounds = result.districtList[0].boundaries
            self.polygon = null
            if (bounds) {
              self.myMap.remove(self.polygons)
              self.polygons = []
              for (let i = 0, l = bounds.length; i < l; i++) {
                self.polygon = new AMap.Polygon({
                  map: self.myMap,
                  strokeWeight: 1,
                  strokeColor: "#0091ea",
                  fillColor: "#80d8ff",
                  fillOpacity: 0.4,
                  path: bounds[i],
                })
                self.polygons.push(self.polygon)
                if (!params) {
                  self.polygon.on("click", function (e) {
                    let lnglat = e.lnglat
                    self.myMap.add(self.marker)
                    self.marker.setPosition(lnglat)
                    geocoder.getAddress(lnglat, function (status, result) {
                      if (status === "complete" && result.regeocode) {
                        var address = result.regeocode.formattedAddress
                        self.formData.address = address
                        self.formData.longitude = lnglat.lng
                        self.formData.latitude = lnglat.lat
                      } else {
                        console.error("根据经纬度查询地址失败")
                      }
                    })
                  })

                  self.myMap.add(self.polygons)

                  self.myMap.add(self.marker)
                  self.marker.setPosition([
                    result.districtList[0].center.lng,
                    result.districtList[0].center.lat,
                  ])
                  self.myMap.setFitView(self.marker)
                  self.myMap.setZoom(11)
                  self.myMap.setFitView() //地图自适应
                } else {
                  if (params.longitude && params.latitude) {
                    self.myMap.add(self.marker)
                    self.marker.setPosition([params.longitude, params.latitude])
                    self.myMap.setFitView(self.marker)
                    self.myMap.setZoom(11)
                  }
                }
              }
            }
          }
        })
      }).catch((err) => {})
    },
    // 社区地址列表
    getCommityList(val) {
      let self = this
      return new Promise((resolve, reject) => {
        self.$http
          .request({
            url: "/ypt/admin/standardAddress/info/StandardAddressTree",
            method: "POST",
            data: {
              jiedaoId: val,
            },
          })
          .then((res) => {
            if (res.code == 200) {
              if (!res.content) {
                resolve([])
                return
              }
              resolve(res.content)
            } else {
              resolve([])
            }
          })
      }).catch((err) => {})
    },
  },
}
</script>

<style lang="less" scoped>
.dialog_container {
  /deep/ .el-dialog__header {
    border-bottom: 1px solid #e5e5e5;
  }
}

.zhiyuanzhe {
  width: 96%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
}

.title-list {
  width: 23%;
  height: 40px;
  line-height: 40px;
  text-align: center;
  background-color: #eeeeee;
  cursor: pointer;
}

.change {
  background-color: #0d2eee;
  color: #ffffff;
}

.tap1 {
  width: 96%;
  margin: 10px auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.tap1-left {
  width: 50%;
  display: flex;
  align-items: center;
}

.tap1-left > div:first-child {
  width: 120px;
  text-align: right;
}

.tap1-right {
  width: 50%;
  display: flex;
  align-items: center;
}

.tap1-right > div:first-child {
  width: 120px;
  text-align: right;
}

.tap1-tbootm {
  width: 100%;
  display: flex;
}

.tap1-tbootm > div:first-child {
  width: 120px;
  text-align: right;
}

.tap1-tbootm > div:nth-child(2) {
  margin-right: 24px;
}

.tap1-tbootm > div:nth-child(3) {
  margin-right: 24px;
}

.tap1-unit {
  width: 100%;
  display: flex;
}

.tap1-unit > div:first-child {
  width: 120px;
  text-align: right;
}

.map_container1 {
  width: 80%;
  margin-left: 140px;
  margin-bottom: 20px;
}

.tap2 {
  width: 96%;
  margin: 10px auto;
  display: flex;
  align-items: center;
}

.tap2-left {
  width: 100px;
  text-align: right;
}

.tap2-content {
  width: 120px;
  text-align: center;
  border: 1px solid #eeeeee;
}

.tap2-content > div:first-child {
  height: 30px;
  line-height: 30px;
  border-bottom: 1px solid #eeeeee;
}

.tap2-content > div:nth-child(2) {
  height: 30px;
  line-height: 30px;
  border-bottom: 1px solid #eeeeee;
}

.tap2-content > div:nth-child(3) {
  height: 30px;
  line-height: 30px;
}

.team2 {
  width: 100%;
  display: flex;
  margin-top: 30px;
}

.team2 > div:first-child {
  width: 120px;
  text-align: right;
}

.tap3 {
  width: 96%;
  margin: 10px auto;
}

.pagination_container {
  margin-top: 20px;
  width: 100%;
  display: flex;
  justify-content: flex-end;
}

.tap4 {
  width: 96%;
  margin: 10px auto;
  display: flex;
}

.tap4 > div:first-child {
  width: 100px;
}

.tap4-text {
  /deep/ .el-textarea__inner {
    resize: none;
  }
}
.addressFrom {
  display: flex;
  margin-right: 130px;
  margin-left: 60px;
  .addressTitle {
    text-align: right;
    vertical-align: middle;
    font-size: 14px;
    color: #606266;
    line-height: 40px;
    padding: 0 12px 0 0;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;

    span {
      color: #f56c6c;
      margin-right: 4px;
    }
  }

  .addressContent {
    flex: 1;

    .addressBox {
      display: flex;

      .addressItem {
        flex: 1;

        /deep/ .el-form-item__content {
          margin-left: 0px !important;
        }

        /deep/ .el-select {
          width: 100% !important;
        }
      }
    }

    /deep/ .el-form-item__content {
      margin-left: 0px !important;
    }
  }
}
</style>
